/**
 * @generated SignedSource<<7849ca920a13f704e862bf49c3ec6adf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RequestTypeCell$data = {
  readonly id: string;
  readonly requestType: {
    readonly avatar: {
      readonly xsmall: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RequestTypeCell";
};
export type RequestTypeCell$key = {
  readonly " $data"?: RequestTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RequestTypeCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "xsmall"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
};

(node as any).hash = "45180e31ad2753123d699f3c255083f3";

export default node;
